import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btn-arrow-down",
  "use": "icon-btn-arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-btn-arrow-down\"><circle cx=\"10\" cy=\"10\" r=\"10\" /><path d=\"M10.1 14.1L5.3 9.4 6.7 8l3.4 3.3 3.2-3.2 1.4 1.4-4.6 4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol